import React from 'react'
import PropTypes from 'prop-types'

const BestPlanAvailable = (props) => {
    return (
        <div className='row text-center'>
            <div className='col-12 col-md-6 offset-md-3'>
                <h3 className='mb-2'>{props.title}</h3>
                <p>{props.description}</p>
            </div>
        </div>
    )
}

BestPlanAvailable.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string
}

BestPlanAvailable.defaultProps = {
    title: 'Good news',
    description: 'The plan you have for this service is the current best-value plan offered by Exetel. There are no alternative plans available.'
}

export default BestPlanAvailable



// WEBPACK FOOTER //
// ./resources/js/components/BestPlanAvailable.js